import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, blueMui, orangeMui } from "@ryde/theme";

export const ProductionHubStatisticsWrapper = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "production-hub-statistics",
  },
)`
  margin-top: 8px;

  .hub-statistics__title {
    font-weight: 600;
    color: ${blueGreyMui._800};
  }

  .hub-main-rides__label,
  .hub-personal-rides__label {
    color: ${orangeMui._800};
    font-weight: 600;
  }

  .hub-bookings-routed__label {
    color: ${blueMui._800};
    font-weight: 600;
  }
`;
